import React from 'react';

interface UpsellCardProps {
  reason?: 'feature_disabled' | 'not_practice_user' | 'unknown';
  onDismiss?: () => void;
}

export const UpsellCard: React.FC<UpsellCardProps> = ({ reason = 'feature_disabled', onDismiss }) => {
  const isLocked = reason === 'feature_disabled';
  return (
    <div className="border rounded-3 p-3 my-3 bg-light" role="region" aria-label="Job description writer upsell">
      <div className="d-flex align-items-start gap-3">
        <div className="flex-shrink-0" aria-hidden="true">
          <span className="badge rounded-pill bg-primary">PREMIUM+</span>
        </div>
        <div className="flex-grow-1">
          <h5 className="mb-1">Get a job description written for you</h5>
          <p className="mb-2 text-muted">
            {isLocked
              ? 'Get a ready-to-post job description written from your job details. Available on paid plans.'
              : 'This account does not have access to the job description writer.'}
          </p>
          <div className="d-flex gap-2">
            {isLocked && (
              <a className="btn btn-primary btn-sm" href="/practice/subscribe">
                Upgrade to Premium+
              </a>
            )}
            {onDismiss && (
              <button
                type="button"
                className="btn btn-link btn-sm text-muted"
                onClick={onDismiss}
              >
                Not now
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpsellCard;
